export const contractTypeMap: { [key: string]: string } = {
    UTBYGGINGSKONTRAKT: "Utbyggingskontrakt",
    DRIFTSKONTRAKT: "Driftskontrakt",
    FAGKONTRAKT: "Fagkontrakt",
    GJENNOMFORINGSKONTRAKT: "Gjennomføringskontrakt",
    SAMLEKONTRAKT: "Samlekontrakt",
    VEDLIKEHOLDSKONTRAKT: "Vedlikeholdskontrakt",
    MAL: "Mal",
    TEST: "Test",
    ANDRE: "Andre",
};

export const contractTypes: ContractType[] = Object.keys(contractTypeMap).map(key => {
    return {value: key, name: contractTypeMap[key]} as ContractType;
});


export type ContractType = {
    name: string,
    value: string,
}





